<template>
    <div class="flex col">    
        <div class="unit_haeder">中国消费扶贫生活馆</div>
        <div class="unit_center">
            <div class="unit_center_search">
                <img class="search_img" src="../assets/images/search.png" alt="" srcset="">
                <input class="search_text" type="text" placeholder="搜索单位名称">
                <span class="search_cancel">取消</span>
            </div>
            <div class="unit_center_select" >
            </div>
            <div class="unit_bjs">
                <div class="footer_name">
                    <div style="color:#B22627;">赣州市章贡区供销农产品配送有限公司</div>
                    <div style="color:#282828;">2791.21万元</div>
                </div>
                <div class="unit_bjs_fot">
                    <van-radio-group v-model="radio" direction="horizontal">
                        <van-radio name="1">全部</van-radio>
                        <van-radio name="2">近一年</van-radio>
                        <van-radio name="3">近半年</van-radio>
                        <van-radio name="4">近一个月</van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="unit_center_footer">
                
                <div class=" flex footer_boxs">
                    <div class="footer_text" style="width: 0.6rem;">序号</div>
                    <div class="footer_text" style="width:1.8rem">时间</div>
                    <div class="footer_text" style="width:2rem">商品</div>
                    <div class="footer_text" style="width:1.2rem">实付款（万元）</div>
                    <div class="footer_text" style="width:1rem">状态</div>
                </div>
                <div class="flex col unit_center_list">
                    <div class="flex row footer_list">
                        <div class="footer_nums flex flex-center" style="width: 0.6rem;">1</div>
                        <div class="flex flex-center footer_nums" style="width:1.8rem">2020-12-12</div>
                        <div class="flex flex-center footer_nums" style="width:2.3rem">德兴市教育体育局sfddsdfssdfds</div>
                        <div class="flex flex-center footer_nums" style="width:1.2rem">130.00</div>
                        <div class=" flex flex-center footer_nums" style="width:1rem">已上报</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pofig flex row">
            <div class="flex-item pofig_item flex row flex-center">
                <img src="../assets/images/Inquire.png" class="pofig_item_imgs" alt="" srcset="">
                单位查询</div>
            <div class="flex-item pofig_item flex row flex-center">
                <img src="../assets/images/statistics.png" class="pofig_item_imgs" alt="" srcset="">
                数据统计</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "login",
    data(){
        return{
            userName:'',
            passWord:'',
            select_name:'',
            value: '',
            radio:1,
            showPicker: false,
            columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],

        }
    },
    components: {
    },
    methods:{
       
    }
}
</script>
<style scoped>
    body{
        background: #999999;
    }
     .unit_haeder{
        height: 1.28rem;
        background: #B22627;
        padding-bottom: 0.2rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
     }
     .unit_center{
         padding: 0.14rem 0.18rem 1.38rem 0.18rem;
         box-sizing: border-box;
     }
     .unit_center_search{
        height: 0.8rem;
        background: #FFFFFF;
        border-radius: 0.05rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.18rem;
        box-sizing: border-box;
        margin-bottom: 0.2rem;
     }
     .search_img{
        height: 0.28rem;
        width: 0.28rem;
     }
     .search_text{
        flex: 1;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.3rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666;
        padding-left: 0.2rem;
        box-sizing: border-box;
     }
     .search_cancel{
        font-size: 0.26rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
     }
     .unit_center_select{
         display: flex;
         flex-direction: row;
         height: 0.8rem;
         margin-bottom: 0.29rem;
     }
     .select_btns{
        width: 1.54rem;
        height: 0.8rem;
        background: #FFFFFF;
        border-radius: 0.05rem;
        text-align: center;
     }
     .unit_center_footer{
         background: #fff;
     }
     .unit_bjs{
        background: #FFFFFF;
        padding: 0 0.12rem;
        box-sizing: border-box;
        border-radius: 0.06rem;
        margin-bottom: 0.15rem;
     }
     .footer_boxs{
         padding:0 0.2rem;
         padding-top: 0.27rem;
         padding-bottom: 0.34rem;
         box-sizing: border-box;
         align-items: center;
     }
     .footer_name{
        height: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        line-height: 0.6rem;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
     }
     .unit_bjs_fot{
         padding-top: 0.5rem;
         padding-bottom: 0.3rem;
         box-sizing: border-box;

     }
     .footer_text{
        font-size: 0.24rem;
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #282828; 
        
     }
     .unit_center_list{
         padding: 0 0.2rem;
         box-sizing: border-box;
     }
     .footer_list{
         height: 0.44rem;
         padding-bottom: 0.19rem;
         box-sizing: border-box;
         border-bottom: 0.01rem solid #DDDDDD;
     }
     .footer_nums{
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
     }
     .pofig{
         position: fixed;
         left: 0;
         bottom: 0;
         height: 0.98rem;
         width: 100%;
     }
     .pofig_item{
        background: #FFFFFF;
        box-shadow: 0px 1px 5px 0px rgba(69, 69, 69, 0.2);
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
     }
     .pofig_item_imgs{
         width: 0.24rem;
         height: 0.26rem;
         margin-right: 0.1rem;
     }
     .van-radio--horizontal{
         margin-right: 0.12rem;
         font-size: 0.24rem;
     }
</style>
   